import React, { Component } from 'react';
import { pages } from 'voyage-assets-sdk'

export default class extends Component {

  render() {
    return (
      <pages.showcase {...this.props}></pages.showcase>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/showcase-landing.js